import { ca } from '@cian/analytics';

import { TOffer } from '../../types/offer';
import { getProducts } from '../../utils/trackings_helpers';

type TrackAddNewUserInChat = {
  offer?: TOffer;
  chatId: string;
  opponentId?: number;
};

export function trackAddNewUserInChat({ offer, chatId, opponentId }: TrackAddNewUserInChat) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Chat',
    action: 'Add_sopr',
    label: 'User',
    products: offer ? getProducts([offer]) : [],
    page: {
      extra: {
        chat_id: chatId,
        opponent_id: opponentId,
      },
    },
  });
}
